import { Config, DeploymentHost, TEnvironment } from "./types";

// =================================================================================================
// Services map indicates the API endpoints for each deployment host
// =================================================================================================

const servicesMap = {
  development: {
    quoteBaseUrl: "https://products.segdevelopment.com/pb-api/quotes",
    pbQuotesApi: "https://products.segdevelopment.com/pb-api/v1",
    nfQuoteBaseUrl: "https://esh8h720oi.execute-api.eu-west-1.amazonaws.com/dev/quote",
    pbv2QuotesApi: "https://api.product.segdevelopment.com/v1"
  },

  staging: {
    quoteBaseUrl: "https://products.segstaging.com/pb-api/quotes",
    pbQuotesApi: "https://products.segstaging.com/pb-api/v1",
    nfQuoteBaseUrl: "https://7xvluwvvt2.execute-api.eu-west-1.amazonaws.com/dev/quote",
    pbv2QuotesApi: "https://api.product.segstaging.com/v1"
  },

  uat: {
    quoteBaseUrl: "https://products.seguat.com/pb-api/quotes",
    pbQuotesApi: "https://products.seguat.com/pb-api/v1",
    nfQuoteBaseUrl: "https://8w4ke8dq4m.execute-api.eu-west-1.amazonaws.com/dev/quote",
    pbv2QuotesApi: "https://api.product.seguat.com/v1"
  },

  production: {
    quoteBaseUrl: "https://products.stubbenedge.com/pb-api/quotes",
    pbQuotesApi: "https://products.stubbenedge.com/pb-api/v1",
    nfQuoteBaseUrl: "https://lo3n2u2l6a.execute-api.eu-west-1.amazonaws.com/dev/quote",
    pbv2QuotesApi: "https://api.insure.stubbenedge.com/v1/wlj-lookups"
  },
};

// =================================================================================================
// Given a hostname, return its associated environment
// e.g. "products.segdevelopment.com" is "development"
// =================================================================================================

export const getEnvironment = (hostname: DeploymentHost): TEnvironment => {
  switch (hostname) {
    case "localhost":
      return "localhost";

    default:
    case "products.segdevelopment.com":
    case "seg-pb-whitelabeljourney-dev.s3-website-eu-west-1.amazonaws.com":
      return "development";

    case "products.segstaging.com":
    case "seg-pb-whitelabeljourney-staging.s3-website-eu-west-1.amazonaws.com":
      return "staging";

    case "products.seguat.com":
      return "uat";

    case "products.stubbenedge.com":
      return "production";
  }
};

// =================================================================================================
// Given a hostname, return a complete config of the API endpoints
// =================================================================================================

export default function getConfig(hostname: DeploymentHost): Config {
  switch (getEnvironment(hostname)) {
    case "localhost":
    case "development":
      return {
        NF_QUOTE_BASE_URL: servicesMap.development.nfQuoteBaseUrl,
        PB_V1_API: servicesMap.development.pbQuotesApi,
        QUOTE_BASE_URL: servicesMap.development.quoteBaseUrl,
        PB_V2_API: servicesMap.development.pbv2QuotesApi,
      };

    case "staging":
      return {
        NF_QUOTE_BASE_URL: servicesMap.staging.nfQuoteBaseUrl,
        PB_V1_API: servicesMap.staging.pbQuotesApi,
        QUOTE_BASE_URL: servicesMap.staging.quoteBaseUrl,
        PB_V2_API: servicesMap.staging.pbv2QuotesApi,
      };

    case "uat":
      return {
        NF_QUOTE_BASE_URL: servicesMap.uat.nfQuoteBaseUrl,
        PB_V1_API: servicesMap.uat.pbQuotesApi,
        QUOTE_BASE_URL: servicesMap.uat.quoteBaseUrl,
        PB_V2_API: servicesMap.uat.pbv2QuotesApi,
      };

    case "production":
      return {
        NF_QUOTE_BASE_URL: servicesMap.production.nfQuoteBaseUrl,
        PB_V1_API: servicesMap.production.pbQuotesApi,
        QUOTE_BASE_URL: servicesMap.production.quoteBaseUrl,
        PB_V2_API: servicesMap.production.pbv2QuotesApi,
      };
  }
}
